var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForwardArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{isolation:isolate;}.b,.c,.d,.f{fill:none;}.b,.c,.d{stroke:#6ac4e7;stroke-width:2px;}.c,.d{stroke-linecap:round;}.d{stroke-linejoin:round;}.e{stroke:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 24,
    cy: 24,
    r: 24
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 24,
    cy: 24,
    r: 23
  })), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(32.607 30.492) rotate(180)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "c",
    x2: 17.169,
    transform: "translate(0.245 6.398)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M6.6,0,0,6.6l6.6,6.6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardArrow);
export default __webpack_public_path__ + "static/media/forwardArrow.9e62471a.svg";
export { ForwardRef as ReactComponent };